export const HIDE_TITLE = 'HIDE_TITLE';
export const SHOW_UPLOAD_RECORD = 'SHOW_UPLOAD_RECORD';
export const SHOW_RECORDING = 'SHOW_RECORDING';
export const SHOW_FILES = 'SHOW_FILES';
export const SHOW_ARTWORK = 'SHOW_ARTWORK';
export const SHOW_OVERVIEW = 'SHOW_OVERVIEW';
export const SHOW_LIBRARY = 'SHOW_LIBRARY';
